import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

let webApiUrl = `${process.env.REACT_APP_BASE_URL}air_12/`;
let tokenStr = process.env.REACT_APP_API_TOKEN;

export const fetchStationsTwelve = createAsyncThunk(
  "stations/fetchStationsTwelve",
  async () => {
    const response = await axios.get(webApiUrl, {
      headers: { Authorization: `Token ${tokenStr}` },
    });
    return response.data;
  }
);

const stationsTwelveSlice = createSlice({
  name: "stationsTwelve",
  initialState: {
    stationsLoading: true,
    stationsData: {
      SAPA: [],
      ESPS: [],
      OSPM: [],
      SATA: [],
    },
    stationsError: "",
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStationsTwelve.pending, (state) => {
        state.stationsLoading = true;
      })
      .addCase(fetchStationsTwelve.fulfilled, (state, action) => {
        state.stationsLoading = false;
        state.stationsData = action.payload;
        state.stationsError = "";
      })
      .addCase(fetchStationsTwelve.rejected, (state, action) => {
        state.stationsLoading = false;
        state.stationsData = {
          SAPA: [],
          ESPS: [],
          OSPM: [],
          SATA: [],
        };
        state.stationsError = action.error.message;
      });
  },
});

export default stationsTwelveSlice.reducer;
